import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import DriverQueueInfo from '../models/DriverQueueInfo';
import DriverQueue, { ResultDriverQueue } from '../models/DriverQueue';
import PickupOrderGha from '../models/PickupOrderGha';

const queueReqHandler = {

  insertDriverInQueue: (ghaId:number, info: DriverQueueInfo): Promise<ApiResponse<boolean>> => {

    return genericApi.post('q' , { ghaId, info });
  },
  insertDriverAppointment: (ghaId:number, type: string, orderNumber?: string, driverId?: number ): Promise<ApiResponse<boolean>> => {
    let data = {};
    if(type == 'driver') {
      data = { ghaId, type, orderNumber };
    } else {
      data = { ghaId, type, driverId };
    }
    return genericApi.post('q/check_in', data);  
  },
  getDriverPickupOrderList: (pickupOrderId: string): Promise<ApiResponse<PickupOrderGha>> => {

    return genericApi.get(`driver_order/${pickupOrderId}`);
  },

  getQueue: (type: string): Promise<ApiResponse<ResultDriverQueue>> => {
    
    return genericApi.get(`q?type=${type}`);
  },

  selectCounter: (counterId: number): any => {
    return genericApi.post(`counter/${counterId}`);
  },

  callDriver: (driverId: number, type: string): any => {
    return genericApi.post(`driver/${driverId}`, { type });
  },

  leaveCounter: (): any => {
    return genericApi.get(`counter`);
  },

  deleteDriverOfQueue: (id: number): Promise<ApiResponse<Array<DriverQueue>>> => {

    return genericApi.delete(`q/${id}`)
  }
};

export default queueReqHandler;